import {ConfigurationValues, ValuesConfigurationProvider} from "./values-configuration-provider";

/* tslint:disable:callable-types */
export function ValuesConfigurationConstructor<T extends { new(...args: any[]): {} }>(
    configurationValues: ConfigurationValues,
    valuesConfigurationProvider: ValuesConfigurationProvider = new ValuesConfigurationProvider()
) {

    return (constructor: T) => {
        // @ts-ignore
        const data = valuesConfigurationProvider.provide(configurationValues);

        return class extends constructor {
            constructor(...args: any[]) {
                super(...args);
                Object.keys(data).forEach((property) => {
                    Object.defineProperty(this, property, {
                        value: data[property],
                        writable: true,
                        configurable: true,
                        enumerable: true,
                    });
                });
            }
        };
    };
}
